module.exports = __webpack_public_path__ + "media/components/lessons/statics/lesson4-9d1a82d1dcd2082715396fce345fd2c1.gif";